import React from 'react'
import Jumbotron from '../components/Jumbotron'
import DemoContents from '../components/DemoContents'

const Embedded = () => {
  return (
    <div>
      <Jumbotron variant="dark" type="embeddedDemo" message="gameLoadsWithinThePage"/>
      <DemoContents
        variant="light"
        iFrameContents={window.amigoGames.openRedDog(true)}
      />
    </div>
  )
}

export default Embedded



// WEBPACK FOOTER //
// ./src/pages/Embedded.js